export const convertDateToGermanString = (date: Date): string => {
    return (
        date.getDate().toString().padStart(2, '0') +
        '.' +
        (date.getMonth() + 1).toString().padStart(2, '0') +
        '.' +
        date.getFullYear()
    );
};

export const convertGermanStringToDate = (dateString: string): Date => {
    const tmp = dateString.split('.');
    return new Date(Number(tmp[2]), Number(tmp[1]) - 1, Number(tmp[0]));
};

export const convertDateStringToGermanString = (dateString: string): string => {
    const tmp = dateString.split('-');
    return tmp[2] + '.' + tmp[1] + '.' + tmp[0];
};

export const DAYS_LIST = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
